export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
    perfil_id: [1, 11],
  },
  {
    title: 'Cadastros',
    icon: 'SettingsIcon',
    perfil_id: [1],
    children: [
      {
        title: 'Usuários',
        route: 'list-users',
        perfil_id: [1],
      },
      {
        title: 'Perfis de Usuários',
        route: 'list-perfil-usuario',
        perfil_id: [1],
      },
      {
        title: 'Cidades de atendimento',
        route: 'list-cidades',
        perfil_id: [1],
      },
      {
        title: 'Centrais',
        route: 'list-centrais',
        perfil_id: [1],
      },
      {
        title: 'Status',
        route: 'list-status',
        perfil_id: [1],
      },
      {
        title: 'Imagem',
        route: 'list-imagem',
        perfil_id: [1],
      },
    ],
  },
  {
    title: 'Atendimentos',
    route: 'list-atendimentos',
    icon: 'FileTextIcon',
    perfil_id: [1, 11],
  },
]
